import { useEffect } from 'react';
import { useChartContext } from '@shopify/polaris-viz-core';
import { getEventName } from './utilities.js';
import { useCallbackRef } from '../useCallbackRef.js';

function useWatchColorVisionEvents({
  type,
  onIndexChange,
  enabled = true
}) {
  const onIndexChangeCallback = useCallbackRef(onIndexChange);
  const {
    id
  } = useChartContext();
  useEffect(() => {
    if (!id || !enabled) {
      return;
    }
    const eventName = getEventName(id, type);
    window.addEventListener(eventName, onIndexChangeCallback);
    return () => {
      window.removeEventListener(eventName, onIndexChangeCallback);
    };
  }, [id, type, onIndexChangeCallback, enabled]);
}

export { useWatchColorVisionEvents };
